/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TemplateInvestigation from './template-investigation';
import TemplateInvestigationDetail from './template-investigation-detail';
import TemplateInvestigationUpdate from './template-investigation-update';
import TemplateInvestigationDeleteDialog from './template-investigation-delete-dialog';

const TemplateInvestigationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TemplateInvestigation />} />
    <Route path="new" element={<TemplateInvestigationUpdate />} />
    <Route path=":id">
      <Route index element={<TemplateInvestigationDetail />} />
      <Route path="edit" element={<TemplateInvestigationUpdate />} />
      <Route path="delete" element={<TemplateInvestigationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TemplateInvestigationRoutes;
